import { MAP_TYPES } from '@deck.gl/carto';

const PARK_SOURCE_ID = 'parkSource';

const source = {
  id: PARK_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.diamond.Parks`',
};

export default source;
